<template>
    <div>
        <div
            v-if="availableMarkets.length"
            :class="(isForSportMarket ? 'special-event-sport-market__wrapper': 'special-event-market__wrapper')
                + (isResults ? ' special-event-results-market__wrapper': '')"
        >
            <div
                v-if="!isForSportMarket"
                class="special-event-market-controls__wrapper"
                @click="onHeaderClick"
            >
                <span>{{name}}</span>
                <span>X</span>
            </div>
            <div
                v-if="header"
                class="special-event-market__container-details--terminal"
            >
                {{ header }}
            </div>
            <div
                class="special-event-market__group-wrapper"
            >
                <div
                    v-for="market in availableMarkets"
                    :key="market.id"
                    class="special-event-market__group"
                >
                    <div class="special-event-market__group-header--terminal">
                        <span>{{ market.name | upperCase }}</span>
                    </div>
                    <div
                        v-show="!!market.footer"
                        class="special-event-market__group-details--terminal"
                    >
                        <span>{{ market.footer }}</span>
                    </div>
                    <SpecialGridRow
                        v-for="specialMarketEvent in filterAvailableMarketEvents(market.specialMarketEvents)"
                        :key="specialMarketEvent.id"
                        :isResults="isResults"
                        :specialMarketEvent="specialMarketEvent"
                        :selections="selectionsByEventId[specialMarketEvent.id]"
                        @oddClick="(oddData) => onOddClick(oddData)"
                    />
                </div>
                <div
                    v-if="footer"
                    class="special-event-market__group-details--terminal"
                >
                    <span>{{ footer }}</span>
                </div>
            </div>
        </div>
        <div
            v-else
            class="primary-market__unavalibale px-3"
        >
            {{ $t('no markets currently available') | upperCase }}
        </div>
    </div>
</template>

<script>
    import { groupBy as _groupBy } from '@lodash';
    import SpecialGridRow from './SpecialGridRow.vue';

    export default {
        name: 'SpecialEvent',
        props: {
            isResults: {
                type: Boolean,
                required: true,
            },
            markets: {
                type: Array,
                required: false,
                default: null,
            },
            name: {
                type: String,
                required: false,
                default: 'Hello Sanja!',
            },
            header: {
                type: String,
                required: false,
                default: '',
            },
            footer: {
                type: String,
                required: false,
                default: '',
            },
            selections: {
                type: Array,
                required: false,
                default: () => [],
            },
            isForSportMarket: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        computed: {
            selectionsByEventId() {
                return _groupBy(this.selections, (x) => x.getEventId());
            },
            /* markets are made of market events. Market events can be unavailable for betting.
             if all market events inside a market are unavailable for betting then the whole
             market is unavailable also and should not be displayed */
            availableMarkets() {
                if (this.isResults) {
                    return this.markets;
                }
                return this.markets.filter((market) => market.isAvailableForBetting());
            },
        },
        methods: {
            hasSpecialBetValue(market) {
                return !!market.specialMarketEvents[0].specialBetValue;
            },
            onOddClick(oddData) {
                const { odd } = oddData;

                if (odd.isLocked) {
                    return;
                }

                this.$emit('oddClick', odd);
            },
            // these filters marketEvents based if they're available for betting
            filterAvailableMarketEvents(market) {
                if (this.isResults) {
                    return market;
                }
                return market.filter((marketEvent) => marketEvent.isAvailableForBetting());
            },
            onHeaderClick() {
                this.$emit('headerClick');
            },
        },
        components: {
            SpecialGridRow
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/special/SpecialEvent.vue